// @flow
import * as React from 'react'
import styled from 'styled-components'
import {translate} from 'react-i18next'
import {
  Banner,
  Grid,
  Section,
  TeamMember
} from 'tutellus-ui'

import {Page} from './Page'

const Team = props =>
  <Grid>{
    props.members.map((member, key) =>
      <TeamMember {...member} key={key} />
    )
  }</Grid>

const Text = styled.p`
    text-align: center;
`

export const AboutUs = translate('aboutus')(({t}) =>
  <Page>
    <Banner background_url={t('background_url')}
      title={t('title')}>
      <small>{ t('our_mission') }</small>
      <br />
      <br />
      { t('description') }
    </Banner>
    <Section title={t('our_team')}>
      <Text>
        { JSON.parse(t('about')).map((paragraph, key) =>
          <React.Fragment key={key}>
            { paragraph }
            <br />
          </React.Fragment>
        ) }
      </Text>
      <Team members={JSON.parse(t('team')).map(member => ({
        badge: ['mcaballero', 'jortiz'].includes(member) && t(`cofounder`),
        name: t(`${member}_name`),
        pics: JSON.parse(t(`${member}_pics`)).map(image =>
          `${t('team_pics_base_url')}/${image}`
        ),
        role: t(`${member}_role`)
      }))} />
    </Section>
  </Page>
)
AboutUs.displayName = 'AboutUs'



// WEBPACK FOOTER //
// ./src/pages/AboutUs.js